module.exports = __webpack_public_path__ + "static/img/8.cc366237.png";